<img [src]="imageSrc"
     [ngStyle]="style"
     (load)="load.emit()"
     (error)="error.emit()" />
